<template>

    <div v-if="fetcher.initialized">

        <div class="mb-10">
            <h2>Anteckningar</h2>
            <div class="custom-form-group">
                <textarea id="contact-log-notes" class="form-control" style="height: 200px;" v-model="company.internal_information"></textarea>
            </div>
            <div class="d-flex justify-content-end">
                <button class="btn btn-primary" :disabled="patcher.submitted" @click="patcherPatch()">
                    <span class="spinner-border spinner-border-sm"></span>
                    Spara
                </button>
            </div>
        </div>

        <div class="mb-8">
            <h2>Kontaktlogg</h2>
            <contact-log-list
                :admins="admins"
                :entries="company.log_info"
                type="info"
                :company="company"
                @refresh="fetcherFetch()"
            />
        </div>

        <div style="margin-bottom:300px;">
            <h2>Datum för nästa kontakt</h2>
            <contact-log-list
                :admins="admins"
                :entries="company.log_contact"
                type="contact"
                :company="company"
                @refresh="fetcherFetch()"
            />
        </div>

    </div>

</template>

<script>
import fetcher from '../../../../shared/mixins/fetcher'
import patcher from '../../../../shared/mixins/patcher'

import contactLogList from './contact-log-list'

export default {

    mixins: [
        patcher,
        fetcher
    ],

    components: {
        contactLogList
    },

    props: {
        company_id: {
            required: true
        }
    },

    data () {
        return {
            company: null,
            admins: [],
            fetcher: {
                autoFill: [
                    'company',
                    'admins'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/companies/' + this.company_id + '/tabContact'
        },
        patcherUrl () {
            return '/companies/' + this.company_id
        },
        patcherData () {
            return {
                internal_information: this.company.internal_information
            }
        }

    },

    methods: {

        patcherSuccess (data) {
            bus.$emit(
                'notify',
                'Anteckningar har sparats'
            )
        }
    }

}
</script>
